import { ExamState } from "@/store/Exam/State";

export class State extends ExamState {}
